// import React, { useEffect, useRef, useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   Box,
//   Typography,
//   TextField,
//   IconButton,
//   Avatar,
//   Divider,
// } from "@mui/material";
// import SendIcon from "@mui/icons-material/Send";
// import CloseIcon from "@mui/icons-material/Close";
// import axios from "../axiosInstance";
// import { socket } from "../socket";
// import dayjs from "dayjs";
// import relativeTime from "dayjs/plugin/relativeTime";

// dayjs.extend(relativeTime);

// const BuyerChatModal = ({ open, onClose, buyer, currentUser, currentMode, onlineUsers }) => {
//   const [messages, setMessages] = useState({ 
//     sellerMessages: [], 
//     buyerMessages: [], 
//     allMessages: [] 
//   });
//   const [input, setInput] = useState("");
//   const [conversationId, setConversationId] = useState(null);
//   const [isTyping, setIsTyping] = useState(false);
//   const typingTimeout = useRef(null);
//   const messagesEndRef = useRef(null);

//   // 🔹 Use allMessages for display
//   const displayedMessages = messages.allMessages || [];
  
//   console.log("BuyerChatModal - messages to display:", displayedMessages);

//   // Scroll to bottom on messages change
//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages]);

//   // Load/Create Conversation
//   useEffect(() => {
//     if (!open || !buyer?.connectionData?.otherUser?._id) return;

//     const initChat = async () => {
//       try {
//         const { data } = await axios.post("/api/v1/chat/conversation", {
//           receiverId: buyer?.connectionData?.otherUser?._id,
//         });
//         setConversationId(data.data._id);

//         const res = await axios.get(`/api/v1/chat/messages/${data.data._id}`);
//         console.log("BuyerChatModal - API response:", res.data);
//         // 🔹 Set the grouped messages object
//         setMessages(res.data.data || { 
//           sellerMessages: [], 
//           buyerMessages: [], 
//           allMessages: [] 
//         });
//       } catch (error) {
//         console.error("Failed to init chat:", error);
//         // Set empty grouped object on error
//         setMessages({ 
//           sellerMessages: [], 
//           buyerMessages: [], 
//           allMessages: [] 
//         });
//       }
//     };

//     initChat();
//   }, [open, buyer]);

//   // Listen incoming messages
//   useEffect(() => {
//     const handleReceiveMessage = (message) => {
//       console.log("BuyerChatModal - New message received:", message);
//       if (message.conversationId === conversationId) {
//         // 🔹 Update grouped messages
//         setMessages(prev => ({
//           sellerMessages: message.mode === "seller" 
//             ? [...prev.sellerMessages, message] 
//             : prev.sellerMessages,
//           buyerMessages: message.mode === "buyer" 
//             ? [...prev.buyerMessages, message] 
//             : prev.buyerMessages,
//           allMessages: [...prev.allMessages, message]
//         }));

//         // MESSAGE DELIVERED
//         socket.emit("messageDelivered", {
//           messageId: message._id,
//           receiverId: message.sender,
//         });
//       }
//     };

//     const handleTyping = ({ conversationId: convId, senderId }) => {
//       if (
//         convId === conversationId &&
//         senderId === buyer?.connectionData?.otherUser?._id
//       ) {
//         setIsTyping(true);
//       }
//     };

//     const handleStopTyping = ({ conversationId: convId, senderId }) => {
//       if (
//         convId === conversationId &&
//         senderId === buyer?.connectionData?.otherUser?._id
//       ) {
//         setIsTyping(false);
//       }
//     };

//     socket.on("receiveMessage", handleReceiveMessage);
//     socket.on("typing", handleTyping);
//     socket.on("stopTyping", handleStopTyping);

//     return () => {
//       socket.off("receiveMessage", handleReceiveMessage);
//       socket.off("typing", handleTyping);
//       socket.off("stopTyping", handleStopTyping);
//     };
//   }, [conversationId, buyer]);

//   // Send message
//   const handleSend = async () => {
//     if (!input.trim()) return;

//     const payload = {
//       conversationId,
//       receiverId: buyer?.connectionData?.otherUser?._id,
//       text: input,
//     };

//     try {
//       const { data } = await axios.post("/api/v1/chat/send", payload);
//       console.log("BuyerChatModal - Message sent:", data.data);
      
//       // 🔹 Update grouped messages
//       setMessages(prev => ({
//         sellerMessages: data.data.mode === "seller" 
//           ? [...prev.sellerMessages, data.data] 
//           : prev.sellerMessages,
//         buyerMessages: data.data.mode === "buyer" 
//           ? [...prev.buyerMessages, data.data] 
//           : prev.buyerMessages,
//         allMessages: [...prev.allMessages, data.data]
//       }));
      
//       setInput("");

//       socket.emit("stopTyping", {
//         conversationId,
//         senderId: currentUser,
//         receiverId: buyer?.connectionData?.otherUser?._id,
//       });
//     } catch (error) {
//       console.error("Failed to send message:", error);
//     }
//   };

//   const handleTyping = (e) => {
//     setInput(e.target.value);

//     socket.emit("typing", {
//       conversationId,
//       senderId: currentUser,
//       receiverId: buyer?.connectionData?.otherUser?._id,
//     });

//     if (typingTimeout.current) clearTimeout(typingTimeout.current);

//     typingTimeout.current = setTimeout(() => {
//       socket.emit("stopTyping", {
//         conversationId,
//         senderId: currentUser,
//         receiverId: buyer?.connectionData?.otherUser?._id,
//       });
//     }, 1500);
//   };

//   // Mark unseen messages as read
//   useEffect(() => {
//     if (!conversationId || !socket) return;

//     const unseenMessages = displayedMessages.filter(
//       (m) => m.sender !== currentUser && !m.isRead
//     );

//     unseenMessages.forEach((msg) => {
//       socket.emit("messageSeen", {
//         messageId: msg._id,
//         userId: currentUser,
//       });
//     });
//   }, [displayedMessages, conversationId, currentUser]);

//   useEffect(() => {
//     const handleMessageSeen = ({ messageId }) => {
//       console.log("BuyerChatModal - Message seen:", messageId);
      
//       // 🔹 Update messages with read status
//       setMessages(prev => ({
//         sellerMessages: prev.sellerMessages.map(m => 
//           m._id === messageId ? { ...m, isRead: true } : m
//         ),
//         buyerMessages: prev.buyerMessages.map(m => 
//           m._id === messageId ? { ...m, isRead: true } : m
//         ),
//         allMessages: prev.allMessages.map(m => 
//           m._id === messageId ? { ...m, isRead: true } : m
//         )
//       }));
//     };

//     socket.on("messageSeen", handleMessageSeen);
//     return () => socket.off("messageSeen", handleMessageSeen);
//   }, []);

//   useEffect(() => {
//     const handleMessageDelivered = ({ messageId }) => {
//       console.log("BuyerChatModal - Message delivered:", messageId);
      
//       // 🔹 Update messages with delivered status
//       setMessages(prev => ({
//         sellerMessages: prev.sellerMessages.map(m => 
//           m._id === messageId ? { ...m, deliveredAt: new Date() } : m
//         ),
//         buyerMessages: prev.buyerMessages.map(m => 
//           m._id === messageId ? { ...m, deliveredAt: new Date() } : m
//         ),
//         allMessages: prev.allMessages.map(m => 
//           m._id === messageId ? { ...m, deliveredAt: new Date() } : m
//         )
//       }));
//     };

//     socket.on("messageDelivered", handleMessageDelivered);
//     return () => socket.off("messageDelivered", handleMessageDelivered);
//   }, []);

//   // 🔹 Helper function to get message style based on mode
//   const getMessageStyle = (msg) => {
//     const isOwnMessage = msg.sender === currentUser;
//     const isSellerModeMessage = msg.mode === "seller";
    
//     if (isOwnMessage) {
//       return {
//         bgcolor: isSellerModeMessage ? "#4CAF50" : "#3066be", // Seller: green, Buyer: blue
//         color: "#fff",
//       };
//     } else {
//       return {
//         bgcolor: isSellerModeMessage ? "#e8f5e8" : "#e5e7eb", // Seller: light green, Buyer: light gray
//         color: "#111",
//         borderLeft: isSellerModeMessage ? "3px solid #4CAF50" : "3px solid #3066be",
//       };
//     }
//   };

//   // 🔹 Helper function to get mode label
//   const getModeLabel = (msg) => {
//     if (msg.sender === currentUser) {
//       return msg.mode === "seller" ? "You (Seller)" : "You (Buyer)";
//     } else {
//       return msg.mode === "seller" ? `${buyer?.name} (Seller)` : `${buyer?.name} (Buyer)`;
//     }
//   };

//   // 🔹 Check if displayedMessages is an array
//   if (!Array.isArray(displayedMessages)) {
//     console.error("displayedMessages is not an array:", displayedMessages);
//     return (
//       <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
//         <DialogTitle>Error</DialogTitle>
//         <DialogContent>
//           <Typography color="error">
//             Error loading messages. Please try again.
//           </Typography>
//         </DialogContent>
//       </Dialog>
//     );
//   }

//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
//       <DialogTitle>
//         <Box display="flex" alignItems="center" justifyContent="space-between">
//           <Box display="flex" alignItems="center" gap={1.5}>
//             <Avatar src={buyer?.profileImage}>{buyer?.name?.[0]}</Avatar>
//             <Box>
//               <Typography fontWeight={600}>{buyer?.name}</Typography>
//               <Typography
//                 variant="caption"
//                 textAlign="center"
//                 sx={{ display: "block", color: "#6b7280" }}
//               >
//                 {onlineUsers.includes(buyer?.buyerId)
//                   ? "Online"
//                   : buyer?.connectionData?.lastSeen
//                   ? `Last seen ${dayjs(
//                       buyer?.connectionData?.lastSeen
//                     ).fromNow()}`
//                   : "Offline"}
//               </Typography>
//               {isTyping && (
//                 <Typography variant="caption" color="primary">
//                   Typing...
//                 </Typography>
//               )}
//             </Box>
//           </Box>
//           <IconButton onClick={onClose}>
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </DialogTitle>

//       <Divider />

//       <DialogContent
//         sx={{
//           height: 380,
//           bgcolor: "#f9fafb",
//           display: "flex",
//           flexDirection: "column",
//           gap: 1.5,
//           overflowY: "auto",
//           p: 2,
//         }}
//       >
//         {displayedMessages.length === 0 ? (
//           <Box sx={{ textAlign: "center", py: 4 }}>
//             <Typography color="textSecondary">
//               No messages yet. Start a conversation!
//             </Typography>
//           </Box>
//         ) : (
//           displayedMessages.map((msg) => {
//             const isOwnMessage = msg.sender === currentUser;
//             const messageStyle = getMessageStyle(msg);
            
//             return (
//               <Box
//                 key={msg._id}
//                 sx={{
//                   alignSelf: isOwnMessage ? "flex-end" : "flex-start",
//                   maxWidth: "85%",
//                   position: "relative",
//                   mb: 1,
//                 }}
//               >
//                 {/* Mode label */}
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     display: "block",
//                     mb: 0.5,
//                     color: "#666",
//                     fontSize: "0.7rem",
//                     fontWeight: 500,
//                     ml: isOwnMessage ? 0 : 1,
//                     mr: isOwnMessage ? 1 : 0,
//                     textAlign: isOwnMessage ? "right" : "left",
//                   }}
//                 >
//                   {getModeLabel(msg)}
//                 </Typography>
                
//                 {/* Message bubble */}
//                 <Box
//                   sx={{
//                     px: 1.5,
//                     py: 1,
//                     borderRadius: 2,
//                     ...messageStyle,
//                     borderTopLeftRadius: isOwnMessage ? 12 : 4,
//                     borderTopRightRadius: isOwnMessage ? 4 : 12,
//                   }}
//                 >
//                   <Typography variant="body2">{msg.text}</Typography>
                  
//                   {/* Message info row */}
//                   <Box
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                       mt: 0.5,
//                     }}
//                   >
//                     <Typography
//                       variant="caption"
//                       sx={{
//                         color: isOwnMessage ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.5)",
//                         fontSize: "0.7rem",
//                       }}
//                     >
//                       {dayjs(msg.createdAt).format("hh:mm A")}
//                     </Typography>
                    
//                     {isOwnMessage && (
//                       <Typography
//                         variant="caption"
//                         sx={{
//                           ml: 1,
//                           fontWeight: 600,
//                           color: msg.isRead
//                             ? isOwnMessage ? "#90caf9" : "#2563eb"
//                             : msg.deliveredAt
//                             ? isOwnMessage ? "#b0bec5" : "#6b7280"
//                             : isOwnMessage ? "#cfd8dc" : "#9ca3af",
//                         }}
//                       >
//                         {msg.isRead ? "✓✓" : msg.deliveredAt ? "✓✓" : "✓"}
//                       </Typography>
//                     )}
//                   </Box>
//                 </Box>
//               </Box>
//             );
//           })
//         )}
//         <div ref={messagesEndRef} />
//       </DialogContent>

//       <Box
//         sx={{ p: 1.5, display: "flex", gap: 1, borderTop: "1px solid #e5e7eb" }}
//       >
//         <TextField
//           fullWidth
//           size="small"
//           placeholder="Type a message..."
//           value={input}
//           onChange={handleTyping}
//           onKeyDown={(e) => e.key === "Enter" && handleSend()}
//         />
//         <IconButton 
//           onClick={handleSend} 
//           color="primary"
//           disabled={!input.trim()}
//         >
//           <SendIcon />
//         </IconButton>
//       </Box>
//     </Dialog>
//   );
// };

// export default BuyerChatModal;

import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  TextField,
  IconButton,
  Avatar,
  Divider,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import CloseIcon from "@mui/icons-material/Close";
import axios from "../axiosInstance";
import { socket } from "../socket";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const BuyerChatModal = ({ open, onClose, buyer, currentUser, currentMode, onlineUsers }) => {
  const [messages, setMessages] = useState({ 
    sellerMessages: [], 
    buyerMessages: [], 
    allMessages: [] 
  });
  const [input, setInput] = useState("");
  const [conversationId, setConversationId] = useState(null);
  const [isTyping, setIsTyping] = useState(false);
  const typingTimeout = useRef(null);
  const messagesEndRef = useRef(null);

  const currentUserRef = useRef(currentUser);

  useEffect(() => {
    currentUserRef.current = currentUser;
    console.log("BuyerChatModal - Updated currentUserRef:", currentUserRef.current);
  }, [currentUser]);
  // 🔹 Use allMessages for display
  const displayedMessages = messages.allMessages || [];
  
  console.log("BuyerChatModal - messages to display:", displayedMessages);

  // Scroll to bottom on messages change
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  // Load/Create Conversation
  useEffect(() => {
    if (!open || !buyer?.connectionData?.otherUser?._id) return;

    const initChat = async () => {
      try {
        const { data } = await axios.post("/api/v1/chat/conversation", {
          receiverId: buyer?.connectionData?.otherUser?._id,
        });
        setConversationId(data.data._id);

        const res = await axios.get(`/api/v1/chat/messages/${data.data._id}`);
        console.log("BuyerChatModal - API response:", res.data);
        // 🔹 Set the grouped messages object
        setMessages(res.data.data || { 
          sellerMessages: [], 
          buyerMessages: [], 
          allMessages: [] 
        });
      } catch (error) {
        console.error("Failed to init chat:", error);
        // Set empty grouped object on error
        setMessages({ 
          sellerMessages: [], 
          buyerMessages: [], 
          allMessages: [] 
        });
      }
    };

    initChat();
  }, [open, buyer]);

  // Listen incoming messages
  useEffect(() => {
    const handleReceiveMessage = (message) => {
      if (message.conversationId === conversationId) {
        // 🔹 Update grouped messages
        setMessages(prev => ({
          sellerMessages: message.mode === "seller" 
            ? [...prev.sellerMessages, message] 
            : prev.sellerMessages,
          buyerMessages: message.mode === "buyer" 
            ? [...prev.buyerMessages, message] 
            : prev.buyerMessages,
          allMessages: [...prev.allMessages, message]
        }));

        // MESSAGE DELIVERED
        socket.emit("messageDelivered", {
          messageId: message._id,
          receiverId: message.sender,
        });
      }
    };

    const handleTyping = ({ conversationId: convId, senderId }) => {
      if (
        convId === conversationId &&
        senderId === buyer?.connectionData?.otherUser?._id
      ) {
        setIsTyping(true);
      }
    };

    const handleStopTyping = ({ conversationId: convId, senderId }) => {
      if (
        convId === conversationId &&
        senderId === buyer?.connectionData?.otherUser?._id
      ) {
        setIsTyping(false);
      }
    };

    socket.on("receiveMessage", handleReceiveMessage);
    socket.on("typing", handleTyping);
    socket.on("stopTyping", handleStopTyping);

    return () => {
      socket.off("receiveMessage", handleReceiveMessage);
      socket.off("typing", handleTyping);
      socket.off("stopTyping", handleStopTyping);
    };
  }, [conversationId, buyer]);

  // Send message
  const handleSend = async () => {
    if (!input.trim()) return;

    const payload = {
      conversationId,
      receiverId: buyer?.connectionData?.otherUser?._id,
      text: input,
    };

    try {
      const { data } = await axios.post("/api/v1/chat/send", payload);
      // 🔹 Update grouped messages
      setMessages(prev => ({
        sellerMessages: data.data.mode === "seller" 
          ? [...prev.sellerMessages, data.data] 
          : prev.sellerMessages,
        buyerMessages: data.data.mode === "buyer" 
          ? [...prev.buyerMessages, data.data] 
          : prev.buyerMessages,
        allMessages: [...prev.allMessages, data.data]
      }));
      
      setInput("");

      socket.emit("stopTyping", {
        conversationId,
        senderId: currentUserRef.current,
        receiverId: buyer?.connectionData?.otherUser?._id,
      });
    } catch (error) {
      console.error("Failed to send message:", error);
    }
  };

  const handleTyping = (e) => {
    setInput(e.target.value);

    socket.emit("typing", {
      conversationId,
      senderId: currentUserRef.current,
      receiverId: buyer?.connectionData?.otherUser?._id,
    });

    if (typingTimeout.current) clearTimeout(typingTimeout.current);

    typingTimeout.current = setTimeout(() => {
      socket.emit("stopTyping", {
        conversationId,
        senderId: currentUserRef.current,
        receiverId: buyer?.connectionData?.otherUser?._id,
      });
    }, 1500);
  };

  // Mark unseen messages as read
  useEffect(() => {
    if (!conversationId || !socket) return;

    const unseenMessages = displayedMessages.filter(
      (m) => m.sender !== currentUserRef.current && !m.isRead
    );

    unseenMessages.forEach((msg) => {
      socket.emit("messageSeen", {
        messageId: msg._id,
        userId: currentUserRef.current,
      });
    });
  }, [displayedMessages, conversationId]);

  useEffect(() => {
    const handleMessageSeen = ({ messageId }) => {
      console.log("BuyerChatModal - Message seen:", messageId);
      
      // 🔹 Update messages with read status
      setMessages(prev => ({
        sellerMessages: prev.sellerMessages.map(m => 
          m._id === messageId ? { ...m, isRead: true } : m
        ),
        buyerMessages: prev.buyerMessages.map(m => 
          m._id === messageId ? { ...m, isRead: true } : m
        ),
        allMessages: prev.allMessages.map(m => 
          m._id === messageId ? { ...m, isRead: true } : m
        )
      }));
    };

    socket.on("messageSeen", handleMessageSeen);
    return () => socket.off("messageSeen", handleMessageSeen);
  }, []);

  useEffect(() => {
    const handleMessageDelivered = ({ messageId }) => {
      console.log("BuyerChatModal - Message delivered:", messageId);
      
      // 🔹 Update messages with delivered status
      setMessages(prev => ({
        sellerMessages: prev.sellerMessages.map(m => 
          m._id === messageId ? { ...m, deliveredAt: new Date() } : m
        ),
        buyerMessages: prev.buyerMessages.map(m => 
          m._id === messageId ? { ...m, deliveredAt: new Date() } : m
        ),
        allMessages: prev.allMessages.map(m => 
          m._id === messageId ? { ...m, deliveredAt: new Date() } : m
        )
      }));
    };

    socket.on("messageDelivered", handleMessageDelivered);
    return () => socket.off("messageDelivered", handleMessageDelivered);
  }, []);

  // 🔹 Helper function to get message style based on mode
  const getMessageStyle = (msg) => {
    const isOwnMessage = msg.sender === currentUserRef.current;
    const isSellerModeMessage = msg.mode === "seller";
    
    console.log(`BuyerChatModal - getMessageStyle:`, {
      messageId: msg._id,
      sender: msg.sender,
      currentUser: currentUserRef.current,
      isOwnMessage,
      mode: msg.mode
    });
    
    if (isOwnMessage) {
      return {
        bgcolor: isSellerModeMessage ? "#4CAF50" : "#3066be", // Seller: green, Buyer: blue
        color: "#fff",
      };
    } else {
      return {
        bgcolor: isSellerModeMessage ? "#e8f5e8" : "#e5e7eb", // Seller: light green, Buyer: light gray
        color: "#111",
        borderLeft: isSellerModeMessage ? "3px solid #4CAF50" : "3px solid #3066be",
      };
    }
  };

  // 🔹 Helper function to get mode label
  const getModeLabel = (msg) => {
    const isOwnMessage = msg.sender === currentUserRef.current;
    
    if (isOwnMessage) {
      return msg.mode === "seller" ? "You (Seller)" : "You (Buyer)";
    } else {
      return msg.mode === "seller" ? `${buyer?.name} (Seller)` : `${buyer?.name} (Buyer)`;
    }
  };

  // 🔹 Check if displayedMessages is an array
  if (!Array.isArray(displayedMessages)) {
    console.error("displayedMessages is not an array:", displayedMessages);
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>Error</DialogTitle>
        <DialogContent>
          <Typography color="error">
            Error loading messages. Please try again.
          </Typography>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center" gap={1.5}>
            <Avatar src={buyer?.profileImage}>{buyer?.name?.[0]}</Avatar>
            <Box>
              <Typography fontWeight={600}>{buyer?.name}</Typography>
              <Typography
                variant="caption"
                textAlign="center"
                sx={{ display: "block", color: "#6b7280" }}
              >
                {onlineUsers.includes(buyer?.buyerId)
                  ? "Online"
                  : buyer?.connectionData?.lastSeen
                  ? `Last seen ${dayjs(
                      buyer?.connectionData?.lastSeen
                    ).fromNow()}`
                  : "Offline"}
              </Typography>
              {isTyping && (
                <Typography variant="caption" color="primary">
                  Typing...
                </Typography>
              )}
            </Box>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <Divider />

      <DialogContent
        sx={{
          height: 380,
          bgcolor: "#f9fafb",
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          overflowY: "auto",
          p: 2,
        }}
      >
        {displayedMessages.length === 0 ? (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography color="textSecondary">
              No messages yet. Start a conversation!
            </Typography>
          </Box>
        ) : (
          displayedMessages.map((msg) => {
            const isOwnMessage = msg.sender === currentUserRef.current;
            const messageStyle = getMessageStyle(msg);
            
            return (
              <Box
                key={msg._id}
                sx={{
                  alignSelf: isOwnMessage ? "flex-end" : "flex-start",
                  maxWidth: "85%",
                  position: "relative",
                  mb: 1,
                }}
              >
                {/* Mode label */}
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mb: 0.5,
                    color: "#666",
                    fontSize: "0.7rem",
                    fontWeight: 500,
                    ml: isOwnMessage ? 0 : 1,
                    mr: isOwnMessage ? 1 : 0,
                    textAlign: isOwnMessage ? "right" : "left",
                  }}
                >
                  {getModeLabel(msg)}
                </Typography>
                
                {/* Message bubble */}
                <Box
                  sx={{
                    px: 1.5,
                    py: 1,
                    borderRadius: 2,
                    ...messageStyle,
                    borderTopLeftRadius: isOwnMessage ? 12 : 4,
                    borderTopRightRadius: isOwnMessage ? 4 : 12,
                  }}
                >
                  <Typography variant="body2">{msg.text}</Typography>
                  
                  {/* Message info row */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mt: 0.5,
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        color: isOwnMessage ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.5)",
                        fontSize: "0.7rem",
                      }}
                    >
                      {dayjs(msg.createdAt).format("hh:mm A")}
                    </Typography>
                    
                    {isOwnMessage && (
                      <Typography
                        variant="caption"
                        sx={{
                          ml: 1,
                          fontWeight: 600,
                          color: msg.isRead
                            ? isOwnMessage ? "#90caf9" : "#2563eb"
                            : msg.deliveredAt
                            ? isOwnMessage ? "#b0bec5" : "#6b7280"
                            : isOwnMessage ? "#cfd8dc" : "#9ca3af",
                        }}
                      >
                        {msg.isRead ? "✓✓" : msg.deliveredAt ? "✓✓" : "✓"}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Box>
            );
          })
        )}
        <div ref={messagesEndRef} />
      </DialogContent>

      <Box
        sx={{ p: 1.5, display: "flex", gap: 1, borderTop: "1px solid #e5e7eb" }}
      >
        <TextField
          fullWidth
          size="small"
          placeholder="Type a message..."
          value={input}
          onChange={handleTyping}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
        />
        <IconButton 
          onClick={handleSend} 
          color="primary"
          disabled={!input.trim()}
        >
          <SendIcon />
        </IconButton>
      </Box>
    </Dialog>
  );
};

export default BuyerChatModal;